import React from "react";
import dialogStyles from "../dialogStyles.module.css";
import * as mime from "react-native-mime-types";
import smetaAxios from "../../../../../SmetaAxios";
import { Prefixes } from "../../../../Tools/ProjectX";

interface Props {
  id: string;
  label: string;
}

interface UpdatesHelp {
  AlfaTesting: string;
  BetaTesting: string;
  ConfigVersion: string;
  FileName: string;
  RCDATA: string;
  SupLicGUID: string;
  mimeType: string;
}

const getUpdatesHelp = async (id: string) => {
  return smetaAxios.get("GetUpdatesHelp", {
    prefix: Prefixes.updates,
    params: { ID: id, Client: "1" },
    loadMask: true,
  });
};

function downloadReport(data: UpdatesHelp) {
  const a = document.createElement("a");
  a.href = "data:" + data.mimeType + ";base64," + data.RCDATA;
  a.download = `${data.FileName}`;
  a.click();
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export default function NotesButton({ id, label }: Props) {
  const onClick = async () => {
    const json = await getUpdatesHelp(id);
    downloadReport({ ...json, mimeType: mime.lookup(json.FileName) || "application/octet-stream" });
  };

  return (
    <a title={`Скачать описание обновления: ${label}`} className={dialogStyles.dialogRef} onClick={onClick}>
      {label}
    </a>
  );
}
